Customer.Tabs ||= {}

class Customer.Tabs.TabView extends Backbone.View
  tagName: 'li'
  className: 'session'

  initialize: (@options = {}) ->
    # This is the tabbableView interface:
    #  - tabName() -> String
    #  - tabId()  -> String (unique)
    @tabbableView = @options.tabbableView || throw new Error('Cannot instantiate a TabView without a tabbableView')
    @listenToTriggers()
    @selected = @options.selected || false

  listenToTriggers: ->
    @listenTo(@tabbableView, 'refresh:tab', @onClickUpdate)
    @listenTo(@tabbableView, 'close:tab', @onClickClose)

  render:(name,counter) ->
    @$el.html(@template @templateOptions())
    if @selected
      @$el.addClass('active')
      @$el.removeClass('highlighted')
    else
      @$el.removeClass('active')
    @delegateEvents()
    @$el.find('.tab').tooltip('hide').attr('data-original-title', @tabName().toString().trim()).tooltip('fixTitle')
    @

  templateOptions: ->
    {name: @tabName(), selected: @selected, iconSelector: @tabbableView.iconSelector()}

  onClickTab: ->
    @_keepCustomerSessionAlive()
    @trigger('selected:tab', @tabId()) unless @selected

  onClickClose: ->
    @_keepCustomerSessionAlive()
    @trigger('closed:tab', @tabId())

  onClickUpdate: ->
    @_keepCustomerSessionAlive()
    @trigger('refresh:tab', @tabId())

  select: ->
    mustRender = !@selected
    @selected = true
    @tabbableView.trigger('focus:in') if @tabbableView.trigger
    @render() if mustRender

  deselect: ->
    mustRender = @selected
    @selected = false
    @tabbableView.trigger('focus:out') if @tabbableView.trigger
    @render() if mustRender

  tabName:(name,counter) ->
    @tabbableView.tabName(name,counter)

  tabId: ->
    @tabbableView.tabId()

  isVisible: ->
    true

  renewTab: (tabbableView) ->
    @tabbableView = tabbableView
    @listenToTriggers()

  highlight: (tabType) ->
    @$el.addClass('highlighted ' + tabType)

  isSelected: ->
    @selected

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
